<template>
  <div class="box-border rounded-lg md:ml-16 py-2">
    <div class="inline-flex flex-wrap h-42 max-w-2xl bg-base pt-5 rounded-md">
      <div
        v-for="(figure, index) in content.value"
        :key="index"
        class="inline-block w-32 h-32 mb-4 cursor-pointer"
      >
        <Figure
          :src="figure.avatar"
          :name="figure.name"
          :index="index"
          @selected="handleSelected"
        />
      </div>
    </div>
    <Card ref="card" :content="content" />
  </div>
</template>

<script lang="ts">
import { Content } from '@forchange/storytime';
import { Vue, Component, Prop } from 'vue-property-decorator';
import Figure from './Figure.vue';
import Card from './Card.vue'

@Component({
  components: {
    Figure,
    Card
  }
})
export default class Figures extends Vue {
  @Prop({ type: Object }) content!: Content & { value: [] };

  handleSelected(index: number) {
    (this.$refs.card as Vue & { open: Function}).open(index)
  }
}
</script>
